import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  type TableOptions,
  useReactTable,
} from '@tanstack/react-table';

type UseLocalDataTableProps<TData> = Omit<
  TableOptions<TData>,
  'getCoreRowModel' | 'getSortedRowModel'
>;

export function useLocalDataTable<TData>(props: UseLocalDataTableProps<TData>) {
  const table = useReactTable({
    ...props,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });
  return { table };
}
